<template>
  <div>
    <!-- eslint-disable vue/no-v-html -->
    <div class="message" v-html="sanitizedText" />
    <!-- eslint-enable -->
    <div v-if="isDisplayingButton" class="quick-reply-panel" style="margin-top: 10px;">
      <button type="button"
              class="quick-reply-button"
              @click="restart"
      >
        {{ message.content.live_chat.restart_button_title }}
      </button>
    </div>
  </div>
</template>

<script>
// @flow
import { mapState } from 'vuex'

import { restartMixin } from '../../../mixins'
import { sanitizedMarkup } from '../../../../common/utils'

export default {
  mixins: [restartMixin],
  props: {
    message: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    ...mapState(['messages']),
    sanitizedText (): string {
      let liveChatText
      if (this.messages.customerSupport) {
        liveChatText = this.message.content.live_chat.text_after_live_chat_active
      } else {
        liveChatText = this.message.content.live_chat.text_not_available
      }

      return sanitizedMarkup(liveChatText, this.message.content.messageId)
    },
    isDisplayingButton (): boolean {
      return !!this.message.content.live_chat.restart_button_title
    }
  },
  methods: {
    async restart () {
      await this.$store.dispatch('addTextMessageToList', this.message.content.live_chat.restart_button_title)
      this.handleRestart()
    }
  }
}
</script>

<style src="../TextMessage/text-message.scss" />
